export enum PERSISTENCE_STATUS {
  NOT_PERSISTED = 'not-persisted',
  PERSISTING = 'persisting',
  PERSISTED = 'persisted',
  ERROR = 'error',
}
